import * as React from 'react';
import * as Styled from './main.styled';

const Main: React.FC = (props) => <Styled.Main {...props} />;

export default Main;
